const getSystemLanguage = () => {
  const userLanguage = navigator.language.substring(0, 2);
  if (userLanguage === 'fr') {
    return userLanguage;
  }
  return 'en';
};

export default getSystemLanguage;
